import { NavLink } from "react-router-dom";
import { Home, IceCream, ShoppingBag, MessageCircle } from "lucide-react";

const items = [
  { to: "/", icon: Home, label: "Home", id: "home" },
  { to: "/products", icon: IceCream, label: "Menu", id: "menu" },
  { to: "/bulk-order", icon: ShoppingBag, label: "Bulk", id: "bulk" },
  { to: "/contact", icon: MessageCircle, label: "Contact", id: "contact" },
];

export default function BottomNav() {
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 md:hidden backdrop-blur-xl bg-cream/95 border-t border-[#F0E4E4]"
      style={{ boxShadow: "0 -8px 32px rgba(42,28,27,0.06)" }}
      data-testid="bottom-nav"
    >
      <div className="grid grid-cols-4 max-w-md mx-auto">
        {items.map(({ to, icon: Icon, label, id }) => (
          <NavLink
            key={to} to={to} end={to === "/"}
            data-testid={`mobile-nav-${id}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 py-3 transition-all ${
                isActive ? "text-holiday-red" : "text-choc/70"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div className={`p-2 rounded-full transition-all ${isActive ? "bg-ice-pink" : ""}`}>
                  <Icon className="w-5 h-5" strokeWidth={2.4} />
                </div>
                <span className="text-[10px] font-bold tracking-wider uppercase">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

